import Heading from '@arianna/design-system/Heading'
import Text from '@arianna/design-system/Text'
import Button from '@arianna/design-system/Button'

interface Props {
  message?: string
}

export default function NotFound({ message = 'Risorsa non trovata' }: Props) {
  return (
    <div
      style={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        padding: 'var(--space-6)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 48,
          fontWeight: 500,
          color: 'var(--ink-4)',
          marginBottom: 'var(--space-4)',
          lineHeight: 1,
        }}
      >
        404
      </div>
      <Heading variant="h2" style={{ color: 'var(--ink)', marginBottom: 'var(--space-3)' }}>
        Non trovato
      </Heading>
      <Text variant="body" style={{ color: 'var(--ink-3)', marginBottom: 'var(--space-6)' }}>
        {message}
      </Text>
      <Button as="a" href="/library" variant="ghost" size="md">
        ← Torna alla libreria
      </Button>
    </div>
  )
}
